import { createStyles } from '@material-ui/core/styles';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../../mui-theme';

const styles = createStyles(theme => ({
  dialogPaper: {
    borderRadius: 2,
    minHeight: '65.1vh',
  },
  warningPaperFullWidth: {
    maxWidth: '58.56vw',
  },
  closeButton: {
    minWidth: '8.41vw',
    width: 'auto',
    height: '7.29vh',
    borderRadius: 2,
    marginBottom: '3.58vh',
    marginRight: 12,
    fontSize: rem(1),
    fontWeight: 500,
    letterSpacing: 1.43,
    lineHeight: 1,
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    color: themeColor.defaultTextColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
    '& .MuiTouchRipple-ripple': {
      color: `${theme.palette.secondary.main}`,
    },
  },
  acceptButton: {
    minWidth: '8.41vw',
    height: '7.29vh',
    borderRadius: 2,
    marginBottom: '3.58vh',
    marginRight: 12,
    fontSize: rem(1),
    fontWeight: 500,
    letterSpacing: 1.43,
    lineHeight: 1,
    boxShadow: `0 1px 1px 0 ${themeColor.semitransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  dialogContainerMain: {
    backgroundColor: themeColor.lightBackground,
    flex: '1 1 0',
    textAlign: 'center',
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: themeColor.lightBackground,
  },
  dialogItemContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1rem 0rem 0rem 1.25rem',
  },
  dialogCancelItemContent: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '1rem 0rem 0rem 1.25rem',
  },
}));

export default styles;
